import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";
import useRestQuery from "@/remoteState/useRestQuery";

export const useContentFeedback = (contentId, skip = false) => {
  return useRestQuery(`${API_BASE_URL}/api/v3/content-feedback/${contentId}/`, {
    skip,
  });
};

export const usePostContentFeedback = () => {
  const postContentFeedback = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${API_BASE_URL}/api/v3/content-feedback/`,
      requestParams,
    );
  }, []);
  return useRestMutation(postContentFeedback);
};
